<template>
  <div class="buttons d-flex ga-2">
    <v-btn
      v-if="item.procedureActions?.primaryAction"
      class="w-100 flex-grow-0 flex-shrink-1"
      color="primary"
      variant="elevated"
      @click.stop="delegateAction(item.procedureActions.primaryAction.action, item)"
    >
      {{ item.procedureActions.primaryAction.actionName }}
    </v-btn>

    <v-menu
      v-if="item.procedureActions?.secondaryActions?.length"
      transition="slide-x-transition"
      location="bottom left"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          class="flex-grow-0"
          color="primary"
          variant="elevated"
          v-bind="props"
          icon="mdi-dots-vertical"
        >
        </v-btn>
      </template>

      <div class="secondaryActions">
        <div
            v-for="action in item.procedureActions.secondaryActions"
            class="secondaryAction"
            :class="{ redTitle: action.color === 'red' }"
            @click="delegateAction(action.action, item)"
        >
          <span class="actionTitle">{{ action.actionName }}</span>
        </div>
      </div>
    </v-menu>

    <ConfirmDialog ref="confirm" />
    <CancelByOrgReasonDlg
        :open="dialogs['cancelProcedure']"
        :procedure="item?.p"
        @procedure-canceled="tableModel.reload()"
        @update:open="$event => (dialogs['cancelProcedure'] = $event)"
    />

    <v-dialog persistent width="300" :model-value="!!loadingDialogText" :scrim="false">
      <v-card color="primary" dark>
        <v-card-text>
          {{ loadingDialogText ? $t(loadingDialogText) : loadingDialogText }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import { ActionList, DialogList } from "@/components/ActionList";
import { mapStores } from 'pinia';
import { useLibraryStore } from "@/stores/library";
import { useDialogStore } from "@/stores/dialog";
import CancelByOrgReasonDlg from './CancelByOrgReasonDlg';

export default {
  name: 'ProcedureActions',
  components: { ConfirmDialog, CancelByOrgReasonDlg },
  props: {
    item: {
      type: Object,
      required: true,
    },
    tableModel: {
      Object,
      required: true,
    },
  },
  data() {
    return {
      loadingDialogText: null,
      dialogs: {
        cancelProcedure: false
      },
    };
  },
  methods: {
    delegateAction(action, item) {
      if (DialogList[action]) {
        this.showDialog = action;
      } else if (ActionList.actionsMap[action]) {
        ActionList.actionsMap[action].handler(this);
      } else {
        this.libraryStore.callActionByCode(action, { procedure: item.p, ctx: this });
      }
    },
  },
  computed: {
    ...mapStores(useLibraryStore),
    ...mapStores(useDialogStore),
    showDialog: {
      get() {
        return false;
      },
      set(newValue) {
        this.dialogs[newValue] = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
}

.secondaryActions {
  display: inline-flex;
  padding: 5px 0;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.4);

  .secondaryAction {
    width: 100%;
    display: flex;
    padding: 10px 20px;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    .actionTitle {
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }

  .redTitle {
    span {
      color: #f00 !important;
    }
  }

  & > .redTitle {
    border: none;
  }

  & > .redTitle ~ .redTitle {
    border: none;
  }

  .secondaryAction:hover {
    background-color: #f5f5f5 !important;
  }
}
</style>
